import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from "./plugins/i18n.js";
import './registerServiceWorker'
// register the plugin on vue
import Toasted from 'vue-toasted';

Vue.use(Toasted, {
  duration: '1000',
  theme: 'bubble',
  position: 'bottom-left',
  keepOnHover: true,
  fullWidth: false
})

Vue.config.productionTip = false
import { rtdbPlugin } from 'vuefire'
import vuetify from './plugins/vuetify'

Vue.use(rtdbPlugin)
new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')
